import React from "react";

const MenuRowButton = React.forwardRef(
  ({ children, className = "", labelClassName = "", rightContent = null, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`menu-item w-full flex items-center justify-between text-gray-200 ${className}`}
        type="button"
        tabIndex={0}
        {...props}
      >
        <span className={`truncate flex-1 text-left select-none ${labelClassName}`}>
          {children}
        </span>
        {rightContent}
      </button>
    );
  }
);

MenuRowButton.displayName = "MenuRowButton";

export default MenuRowButton;
